module.exports = __webpack_public_path__ + "media/images/big/img4-e7a7d74c7377562de926b19240b99ab2.jpg";